export const peiAcademicProgressLogTypefrom = Object.freeze({
  ReplacementDocument: 1,
  ChangeStatus: 2,
  ChangeDiscussionDate: 3,
});
